import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics"
import { createContext, useContext, useEffect, useState } from "react";
import { useSession } from "./useSession";

const FirebaseContext = createContext();

export function FirebaseProvider({ children }) {
  const [configFirebase, setConfigFirebase] = useState();
  const { session } = useSession();

  useEffect(() => {
    if (window.location.pathname !== "/autenticacao" && session?.idvarejista) {
      const urlAppJson = `https://gswebhost.s3.amazonaws.com/zoomboxapp/${session.idvarejista}/personalizacao/default/app.json`;

      fetch(urlAppJson, {
        method: "GET",
      })
        .then(async (response) => {
          const data = await response.json();
          const config = data.firebaseConfig;

          setConfigFirebase(config);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [session]);

  const firebase = configFirebase ? initializeApp(configFirebase) : null;
  const analytics = configFirebase ? getAnalytics() : null;

  const analyticsEvent = (event, params) => {
    if(analytics) {
      return logEvent(analytics, event, params);
    }
    return;
  };
  

  return (
    <FirebaseContext.Provider value={{firebase, analyticsEvent}}>{children}</FirebaseContext.Provider>
  );
}

export function useFirebase() {
  const context = useContext(FirebaseContext);

  const {firebase, analyticsEvent} = context;

  return {firebase, analyticsEvent};
}
